import React, { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, CircularProgress } from "@mui/material";
import { useGenerateCertificateMutation, useGetProfileQuery } from "../services/auth";
import { toast } from "react-toastify";
import { formatOrSplitPhoneNumber } from "../utils/profile";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  claimData: any;
}

export default function CertificateModal({
  open,
  onClose,
  setOpen,
  claimData,
}: ModalProps) {
  const [generateCertificate, { isLoading }] = useGenerateCertificateMutation();
  const { data: profileRes } = useGetProfileQuery(undefined, { skip: !open });

  const profileData = profileRes?.data || profileRes;
  const rawPhone = claimData?.phone_number || claimData?.phone || profileData?.phone_number || profileData?.phone;
  const rawCc = claimData?.country_code || profileData?.country_code;
  const phoneInfo = formatOrSplitPhoneNumber(rawPhone, rawCc);

  const handleDownload = async () => {
    const designId = claimData?.design_id || claimData?.id || claimData?.data?.design_id;
    if (!designId) {
      toast.error("Design ID is missing.");
      return;
    }
    try {
      const payload: any = {
        design_id: designId,
        use_s3: true,
      };

      const res = await generateCertificate(payload).unwrap();
      
      const certificateUrl = res?.data?.certificate_url || res?.certificate_url || res?.s3_url || res?.data?.s3_url || res?.url || res?.data?.url;
      
      if (certificateUrl) {
        window.open(certificateUrl, "_blank");
        toast.success("Certificate downloaded successfully!");
        setOpen(false);
      } else {
        toast.error("Failed to retrieve certificate URL.");
      }
    } catch (err: any) {
      toast.error(err?.data?.message || err?.message || "Failed to generate certificate");
    }
  };

  return (
    <Modal
      className="modal addNotification_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog" style={{ maxWidth: '600px' }}>
        <div className="modal-body" style={{ background: '#1e1e1e', color: '#ffffff', borderRadius: '12px' }}>
          <div className="modal_title" style={{ borderBottom: '1px solid #333', paddingBottom: '15px' }}>
            <h2 style={{ color: '#fff' }}>Ownership Certificate</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              style={{ filter: 'invert(1)' }}
            >
              <CloseIcon style={{ color: '#fff' }} />
            </button>
          </div>

          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <h1 style={{ color: '#4ADE80', marginBottom: '10px' }}>Certificate of Ownership</h1>
            <p style={{ marginBottom: '20px', color: '#aaa' }}>This certifies that</p>
            <h2 style={{ marginBottom: '20px', fontSize: '24px', color: '#fff' }}>{claimData?.owner_name || claimData?.data?.owner_name || 'Owner'}</h2>
            <p style={{ marginBottom: '20px', color: '#aaa' }}>is the rightful owner of the design</p>
            <h3 style={{ marginBottom: '10px', color: '#fff' }}>{claimData?.title || claimData?.data?.title || 'Design Title'}</h3>
            <p style={{ marginBottom: '5px', fontSize: '14px', color: '#888' }}>Design ID: {claimData?.design_id}</p>
            {(phoneInfo.country_code || phoneInfo.phone_number) && (
              <p style={{ marginBottom: '5px', fontSize: '14px', color: '#888' }}>
                Country Code: <span style={{ color: '#fff' }}>{phoneInfo.country_code || '-'}</span> | Phone: <span style={{ color: '#fff' }}>{phoneInfo.phone_number || '-'}</span>
              </p>
            )}
            <p style={{ marginBottom: '20px', fontSize: '14px', color: '#888' }}>
              Claimed Date: {claimData?.claimed_at || claimData?.data?.claimed_at ? new Date(claimData.claimed_at || claimData.data.claimed_at).toLocaleDateString() : '-'}
            </p>
            
            {(claimData?.preview_url || claimData?.data?.preview_url) && (
              <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                <img 
                  src={claimData.preview_url || claimData.data.preview_url} 
                  alt="Design Preview" 
                  style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '8px', border: '1px solid #333' }} 
                />
              </div>
            )}
          </div>

          <div className="footer_btn_flex" style={{ justifyContent: 'center' }}>
            <Button
              className="btn btn_primary"
              onClick={handleDownload}
              disabled={isLoading}
              style={{ padding: '10px 30px', fontSize: '16px', background: '#4ADE80', color: '#000', fontWeight: 'bold' }}
            >
              {isLoading ? <CircularProgress size={24} color="inherit" style={{ marginRight: '10px' }} /> : null}
              {isLoading ? 'Generating...' : 'Download Certificate'}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
